import { VitalSignsKeys } from '@/components/patient/models/VitalSignsKeys'
import type { VitalSignItemDTO } from '@/generated'

const keysWithDecimalValues: VitalSignsKeys[] = [VitalSignsKeys.K]

export const keysWithTwoDecimalPlaces: VitalSignsKeys[] = [
  VitalSignsKeys.LACTATE,
  VitalSignsKeys.PH,
  VitalSignsKeys.GFR
]

export const formatLaboratoryData = (laboratory: VitalSignItemDTO[]) => {
  return laboratory.map((item) => {
    const key = item.typeKey
    let decimalPlaces = 0

    if (keysWithTwoDecimalPlaces.includes(key as VitalSignsKeys)) {
      decimalPlaces = 2
    } else if (keysWithDecimalValues.includes(key as VitalSignsKeys)) {
      decimalPlaces = 1
    }

    return {
      ...item,
      numericValue: Number(item.numericValue.toFixed(decimalPlaces))
    }
  })
}
